// src/modules/app-views/account/pages/Init/modals/TeamInvitationModal/Step2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import SimpleEmail from 'components/SimpleComponents/SimpleEmail';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import translateX from 'utils/translateX';
import { accessProfileOptions } from 'modules/app-views/account/components/AccessProfileSelect';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const DetailsStepContent = ({ nameLocked, profileLocked, hideName }) => {
  const options = useMemo(() => accessProfileOptions() || [], []);

  return (
    <>
      <SimpleEmail name="email" disabled />
      {!hideName && <SimpleInput name="name" required disabled={nameLocked} />}
      <SimpleSelect
        name="profile"
        label="access_profile"
        required
        options={options}
        placeholder={translateX('select_an_access_profile')}
        disabled={profileLocked}
      />
    </>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const detailsStep = ({ nameLocked, profileLocked, foundProfile, hideName = false }) => ({
  stepTitle: 'details',
  stepTooltip: 'complete_details',
  content: () => (
    <DetailsStepContent
      nameLocked={nameLocked}
      profileLocked={profileLocked}
      hideName={hideName}
    />
  ),
  validationFields: hideName ? ['profile'] : ['name', 'profile'],
  // Dynamic confirm: if owner or keyUser, this is the last step (skip Step 3 RBAC)
  isConfirmStep: ({ form }) => {
    const profile = form?.getFieldValue('profile');
    return ['owner', 'keyUser'].includes(profile);
  },
  onEnter: ({ goFocus }) => {
    // Focus logic:
    // - If name is locked and profile is locked: no focus needed (all fields filled)
    // - If name is locked but profile is not: focus on profile
    // - If name is not locked: focus on name
    if (nameLocked && profileLocked) {
      // All fields are pre-filled and locked, no focus needed
      return;
    }
    setTimeout(() => goFocus?.(nameLocked ? 'profile' : 'name'), 0);
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default detailsStep;
